import { AUDIT_STANDARDS } from "../AuditMap/AuditMap";

export const MASTER_POLICIES = [
  // ── Con plantilla en el Repositorio ──────────────────────────────────────
  { code: "POL-CER-01", title: "Política de Conducta Empresarial Responsable",        sub: "Política paraguas de CER",                              cat: "paraguas", catLabel: "Paraguas", inRepo: true  },
  { code: "POL-SST-02", title: "Política y Procedimiento de SST",                     sub: "Incluye Procedimiento de Retiro Inmediato",              cat: "sst",      catLabel: "SST",      inRepo: true  },
  { code: "POL-VSBG-03",title: "Política de Prevención de Acoso Sexual y VSBG",       sub: "Basada en OIT C190",                                    cat: "genero",   catLabel: "Género",   inRepo: true  },
  { code: "POL-TI-04",  title: "Política contra el Trabajo Infantil",                 sub: "OIT C138/C182",                                         cat: "laboral",  catLabel: "Laboral",  inRepo: true  },
  { code: "POL-TF-05",  title: "Política contra Trabajo Forzoso y Reclutamiento Responsable", sub: "OIT C29 + Employer Pays",                       cat: "laboral",  catLabel: "Laboral",  inRepo: true  },
  { code: "POL-TT-06",  title: "Política de Tiempo de Trabajo",                       sub: "Jornada · horas extras · descanso",                     cat: "laboral",  catLabel: "Laboral",  inRepo: true  },
  { code: "POL-SAL-07", title: "Política de Salarios y Living Wage",                  sub: "Mínimo · igualdad · progresión a living wage",           cat: "laboral",  catLabel: "Laboral",  inRepo: true  },
  { code: "POL-LSNC-08",title: "Política de Libertad Sindical y Negociación Colectiva", sub: "OIT C87/C98",                                         cat: "laboral",  catLabel: "Laboral",  inRepo: true  },
  { code: "PRO-OLGM-09",title: "Procedimiento del Mecanismo de Reclamación (OLGM)",   sub: "7 criterios UNGP 31",                                   cat: "reparacion",catLabel: "Reparación",inRepo: true  },
  { code: "POL-DISC-10",title: "Política de No Discriminación e Igualdad",            sub: "OIT C100/C111",                                         cat: "genero",   catLabel: "Género",   inRepo: true  },
  // ── Sin plantilla en Repositorio (todavía) ───────────────────────────────
  { code: "POL-AMB-11", title: "Política Ambiental",                                  sub: "Cumplimiento normativo · residuos · emisiones · agua · químicos", cat: "ambiental",catLabel: "Ambiental",inRepo: false, note: "Requerida por SMETA Pilar 3, BSCI PA12, WRAP 10, SLCP/FSLM environmental, GRI 300 series" },
  { code: "POL-ETIC-12",title: "Política de Ética Empresarial y Antisoborno",         sub: "Antifraude · conflicto de intereses · regalos · canal de denuncia", cat: "etica",catLabel: "Ética",inRepo: false, note: "Requerida por SMETA Pilar 4, BSCI PA13, WRAP 12" },
  { code: "POL-DISC-13",title: "Política Disciplinaria",                              sub: "Procedimiento disciplinario justo · sin castigo físico/verbal · debido proceso", cat: "gestion",catLabel: "Gestión",inRepo: false, note: "Requerida por SA8000 §6, integrable con POL-VSBG-03" },
  { code: "POL-CONTR-14",title: "Política de Contratos y Empleo Regular",             sub: "Contratos escritos · sin abuso de temporales · período de prueba · terminación", cat: "gestion",catLabel: "Gestión",inRepo: false, note: "Requerida por SMETA 1H, BSCI PA10, ETI Base Code §8, FLA §10" },
  { code: "POL-SUBC-15",title: "Política de Subcontratación y Visibilidad de Sub-tier", sub: "Autorización · DD sobre subcontratistas · trazabilidad de cadena", cat: "gestion",catLabel: "Gestión",inRepo: false, note: "Requerida por SMETA 6, OCDE Recuadro 2, BSCI PA1" },
  { code: "POL-HW-16",  title: "Política de Trabajadores a Domicilio (Homeworkers)",  sub: "OIT C177 · igualdad de trato · trazabilidad · contratos escritos", cat: "laboral",catLabel: "Laboral",inRepo: false, note: "Requerida por SMETA 6, OCDE Módulo 12 — aplicable solo si el modelo incluye homeworking" },
  { code: "POL-CSR-17", title: "Política de Compras Responsables (Responsible Sourcing)", sub: "Para marcas y compradores · Recuadro 4 OCDE · CFRPP · pricing model", cat: "gestion",catLabel: "Gestión",inRepo: false, note: "Requerida por OCDE Recuadro 4 + Sec 1.1 — aplicable cuando la entidad actúa como comprador / marca" },
  { code: "PRO-EMERG-18",title: "Procedimiento de Preparación y Respuesta a Emergencias", sub: "Incendios · evacuación · primeros auxilios · simulacros", cat: "sst",catLabel: "SST",inRepo: false, note: "Requerida por SLCP/FSLM F, Better Work CAT OSH · complementaria a POL-SST-02" },
  { code: "PRO-QUIM-19",title: "Procedimiento de Gestión de Productos Químicos",      sub: "Inventario · MSDS · almacenamiento · MRSL · ZDHC",       cat: "sst",catLabel: "SST",inRepo: false, note: "Requerida por OIT C170, SLCP/FSLM F, ZDHC MRSL — complementaria a POL-SST-02" },
  { code: "POL-DATOS-20",title: "Política de Privacidad de Datos del Trabajador",     sub: "Recolección · almacenamiento · acceso · GDPR-equivalente", cat: "gestion",catLabel: "Gestión",inRepo: false, note: "Requerida por GRI 418, SLCP/FSLM (algunos puntos), CSRD UE para compañías cubiertas" },
];

const EXTRA_REQUIREMENTS = {
  "POL-AMB-11":  [{ stdCode: "SMETA", secN: "3", secTitle: "Medio Ambiente" }, { stdCode: "amfori BSCI", secN: "PA12", secTitle: "Protección del Medio Ambiente" }, { stdCode: "WRAP", secN: "10", secTitle: "Medio Ambiente" }, { stdCode: "GRI", secN: "300", secTitle: "Topic Standards ambientales" }],
  "POL-ETIC-12": [{ stdCode: "SMETA", secN: "4", secTitle: "Ética Empresarial" }, { stdCode: "amfori BSCI", secN: "PA13", secTitle: "Conducta Empresarial Ética" }, { stdCode: "WRAP", secN: "12", secTitle: "Seguridad" }],
  "POL-DISC-13": [{ stdCode: "SA8000", secN: "6", secTitle: "Prácticas Disciplinarias" }],
  "POL-CONTR-14":[{ stdCode: "SMETA", secN: "1H", secTitle: "Empleo regular" }, { stdCode: "amfori BSCI", secN: "PA10", secTitle: "Sin Empleo Precario" }, { stdCode: "ETI Base Code", secN: "8", secTitle: "Empleo regular" }, { stdCode: "FLA Code", secN: "10", secTitle: "Termination and Retrenchment" }, { stdCode: "WRAP", secN: "1", secTitle: "Cumplimiento de leyes" }],
  "POL-SUBC-15": [{ stdCode: "SMETA", secN: "6", secTitle: "Subcontratación y trabajo a domicilio" }, { stdCode: "amfori BSCI", secN: "PA1", secTitle: "Sistema de Gestión Social" }],
  "POL-HW-16":   [{ stdCode: "SMETA", secN: "6", secTitle: "Subcontratación y trabajo a domicilio" }],
  "POL-CSR-17":  [],
  "PRO-EMERG-18":[{ stdCode: "SLCP / FSLM", secN: "F", secTitle: "Health & Safety" }, { stdCode: "Better Work CAT", secN: "OS", secTitle: "OSH — Emergency Preparedness" }],
  "PRO-QUIM-19": [{ stdCode: "SLCP / FSLM", secN: "F", secTitle: "Health & Safety" }, { stdCode: "Better Work CAT", secN: "OS", secTitle: "OSH — Chemicals and Hazardous Substances" }],
  "POL-DATOS-20":[{ stdCode: "GRI", secN: "418", secTitle: "Privacidad" }],
};

export function policyRequirements(code) {
  const fromMap = [];
  AUDIT_STANDARDS.forEach(std => {
    std.sections.forEach(sec => {
      if (sec.tmpl.includes(code)) fromMap.push({ stdCode: std.code, secN: sec.n, secTitle: sec.title });
    });
  });
  return [...fromMap, ...(EXTRA_REQUIREMENTS[code] || [])];
}

export const STATUS_LABELS = {
  vigente:     "✓ Vigente",
  en_revision: "◐ En revisión",
  borrador:    "○ Borrador",
  vencida:     "⚠ Vencida",
  no_tiene:    "— No tiene",
};

export const STATUS_OPTIONS = ["no_tiene", "borrador", "en_revision", "vigente", "vencida"];

export const CAT_OPTIONS = [
  { value: "paraguas",  label: "Paraguas / CER" },
  { value: "laboral",   label: "Derechos laborales" },
  { value: "sst",       label: "SST y bienestar" },
  { value: "genero",    label: "Género y no discriminación" },
  { value: "reparacion",label: "Reparación / OLGM" },
  { value: "ambiental", label: "Ambiental" },
  { value: "etica",     label: "Ética empresarial" },
  { value: "gestion",   label: "Gestión / contratos" },
];

export const STD_OPTIONS = [
  { value: "SMETA",          label: "SMETA" },
  { value: "amfori BSCI",    label: "amfori BSCI" },
  { value: "SA8000",         label: "SA8000" },
  { value: "WRAP",           label: "WRAP" },
  { value: "SLCP / FSLM",   label: "SLCP / Higg FSLM" },
  { value: "Better Work CAT",label: "Better Work CAT" },
  { value: "FLA Code",       label: "FLA Code" },
  { value: "ETI Base Code",  label: "ETI Base Code" },
  { value: "GRI",            label: "GRI Standards" },
];

export function emptyData() {
  return { status: "no_tiene", lastReview: "", approvedBy: "", languages: { sp: false, pt: false, en: false }, trainingPct: 0, notes: "", file: null };
}

export function trBuildDefault() {
  const data = {};
  MASTER_POLICIES.forEach(p => { data[p.code] = emptyData(); });
  return data;
}

export function trMergeWithDefaults(data) {
  const merged = { ...data };
  MASTER_POLICIES.forEach(p => { if (!merged[p.code]) merged[p.code] = emptyData(); });
  return merged;
}

export function trCalcNextReview(lastReview) {
  if (!lastReview) return "";
  try { const d = new Date(lastReview); d.setMonth(d.getMonth() + 24); return d.toISOString().slice(0, 10); } catch (e) { return ""; }
}

export function trDaysUntil(code, data) {
  const d = data[code];
  if (!d?.lastReview) return null;
  const next = trCalcNextReview(d.lastReview);
  if (!next) return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return Math.round((new Date(next) - today) / 86400000);
}

export function trEffectiveStatus(code, data) {
  const d = data[code];
  if (!d) return "no_tiene";
  if (d.status === "vigente") {
    const days = trDaysUntil(code, data);
    if (days !== null && days < 0) return "vencida";
  }
  return d.status;
}
